"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const global_1 = require("./global");
const configOverrides = (global_1.global.ATLANTIS_ENV || {}).config || {};
exports.config = Object.freeze(Object.assign({ defaultCurrency: "USD", errorNotifier(message, error) {
        console.error(message, error);
    } }, configOverrides));
